export class MessageModalController {

  constructor($scope, $modalInstance) {
    $scope.vm = this;
    this.modalInstance = $modalInstance;
    this.scope = $scope;
    this.init();
  }

  init(){
    this.scope.cancel = () => {
      this.modalInstance.dismiss('cancel');
    };

    this.scope.createChat = (data) => {
      this.modalInstance.close(data);
    };
  }
}
